import { render, staticRenderFns } from "./ManagementMobile.vue?vue&type=template&id=3ded35d2&scoped=true"
import script from "./ManagementMobile.vue?vue&type=script&lang=js"
export * from "./ManagementMobile.vue?vue&type=script&lang=js"
import style0 from "./ManagementMobile.vue?vue&type=style&index=0&id=3ded35d2&prod&scoped=true&lang=css"
import style1 from "./ManagementMobile.vue?vue&type=style&index=1&id=3ded35d2&prod&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3ded35d2",
  null
  
)

export default component.exports